import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    title: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
      fontSize: 12,
      fontWeight: 500,
      zIndex: 2,
    },

    item: {
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '9px 10px',
      display: 'flex',
    },
    icon: { fontSize: 15 },
    avatar: {
      cursor: 'pointer',
      width: 20,
      height: 20,
      marginLeft: 15,
    },
    avatarYellow: {
      backgroundColor: palette.lightNavCompanyContextActions,
      color: palette.navCompanyContextActions,
      cursor: 'pointer',
      width: 20,
      height: 20,
      marginLeft: 15,
    },
    avatarGreen: {
      backgroundColor: palette.lightNavAdminActions,
      color: palette.navAdminActions,
      cursor: 'pointer',
      width: 20,
      height: 20,
      marginLeft: 15,
    },
    avatarGray: {
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navSuperAdminActions,
      cursor: 'pointer',
      width: 20,
      height: 20,
      marginLeft: 15,
    },
    avatarBlue: {
      backgroundColor: palette.lightNavOperatorActions,
      color: palette.navOperator,
      cursor: 'pointer',
      width: 20,
      height: 20,
      marginLeft: 15,
    },
    iconGrid: { justifyContent: 'space-between', alignItems: 'center' },
    line: {
      justifyContent: 'space-between',
      alignItems: 'center',
      display: 'flex',
    },
  });

export const overrideCard = () => {
  const overrideStyles = {
    minHeight: 50,
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  };

  return overrideStyles;
};
